import React from 'react';
import { MapItTextField } from "src/components/common";
import { includes } from 'lodash';

const MapItLocalizedNumberTextField = ({ type, min, name, value, handleChange, allowDecimals = true, max, ...props }) => {

  const numberInputAllowableSpecialCharacters = ['e', '+', '-'];

  const keyDownHandlerForNumberInputs = keyDownEvent => {
    if (includes(numberInputAllowableSpecialCharacters, keyDownEvent.key))
      keyDownEvent.preventDefault();
    if (keyDownEvent.key === "ArrowUp") {
      increment()
    }

    if (keyDownEvent.key === "ArrowDown" && (min && value ? Number(value) > min : Number(value) > 0)) {
      decrement()
    }
  }

  const increment = _ => {
    if (!!max && Number(value) > max) return

    handleChange && (value || value === "") && handleChange({ target: { name, value: Number(value) + 1 } });
  }

  const decrement = _ => {
    if (!!max && Number(value) > max) return

    handleChange && value && handleChange({ target: { name: name, value: Number(value) - 1 } });
  }

  const parseHindiAndPersianNumbers = str => {
    return str.replace(/[٠١٢٣٤٥٦٧٨٩]/g, function (d) {
      return d.charCodeAt(0) - 1632;
    }).replace(/[۰۱۲۳۴۵۶۷۸۹]/g, function (d) {
      return d.charCodeAt(0) - 1776;
    });
  }

  const changeHandlerForNumberInputs = changeEvent => {
    let { value } = changeEvent.target;
    value = parseHindiAndPersianNumbers(value);

    // prevent leading zero
    if (value.slice(0, 1) === "0" && value.length > 1 && value.slice(1, 2) !== ".") {
      value = value.substring(1)
    }
    // check for min value, prevent NaN, prevent decimals if allowDecimals = false
    if (
      (min && value !== "" && Number(value) < min) ||
      isNaN(Number(value)) ||
      (includes(value, '.') && !allowDecimals)
    ) return changeEvent.preventDefault()

    if(!!max && Number(value) > max) return
    
    const newEvent = { target: { name: changeEvent.target.name, value } }
    handleChange && handleChange(newEvent);
  }

  return (
    <MapItTextField
      name={name}
      value={value}
      // if type is set to number, hindi numers will be blocked
      inputProps={{ onKeyDown: keyDownHandlerForNumberInputs }}
      handleChange={changeHandlerForNumberInputs}
      size="small"
      sx={{
        'input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
          'WebkitAppearance': 'none',
          margin: 0,
        },
        'input[type=number]': {
          'MozAppearance': 'textfield',
        }
      }}
      {...props}
    />
  )
}

export default MapItLocalizedNumberTextField;